import { combineReducers } from "redux";
import { userReducer } from "./appReducer";

const reducers = combineReducers({
  user: userReducer,
});

export default reducers;
